export default function extractCustomClassName(style) {
  if (style._className) {
    var cls = style._className + ' ';
    delete style._className;
    return cls;
  }

  return '';
}